export default __webpack_public_path__ + "static/nc_logo.0809bdd712d96cdc2731287e1b25015d.png";